<template>
  <div class="subagents_wrap">
    <div class="toolbar">
      <el-form :inline="true" :model="queryForm" class="query_form">
        <el-form-item label="所属员工">
          <el-select v-model="agentId" placeholder="选择数字员工" filterable style="width: 180px"
                     @change="onAgentChange">
            <el-option v-for="a in agentOptions" :key="a.agent_id"
                       :label="a.display_name || a.name" :value="a.agent_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="queryForm.name" placeholder="名称模糊搜索" clearable
                    style="width: 160px" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.enabled" placeholder="全部" clearable style="width: 110px">
            <el-option label="启用" :value="true" />
            <el-option label="停用" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="onSearch">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button v-if="canWrite" type="primary" icon="el-icon-plus"
                 :disabled="!agentId" @click="openAdd">新增子代理</el-button>
    </div>

    <div class="sa_cards" v-loading="loading">
      <div v-for="row in tableData" :key="row.sub_agent_id" class="sa_card">
        <div class="card_head">
          <i class="el-icon-s-promotion card_icon"></i>
          <span class="card_name" :title="row.name">{{ row.display_name || row.name }}</span>
          <el-tag :type="row.enabled ? 'success' : 'info'" size="mini">
            {{ row.enabled ? '启用' : '停用' }}
          </el-tag>
          <i v-if="canWrite" class="el-icon-delete card_del" title="删除" @click.stop="handleDel(row)"></i>
        </div>
        <div class="card_summary">{{ row.description || '（暂无职责描述）' }}</div>
        <div class="card_meta">
          <div class="meta_row"><span class="meta_k">调用名</span><span>{{ row.name }}</span></div>
          <div class="meta_row"><span class="meta_k">迭代轮次</span><span>{{ row.max_iterations || 6 }}</span></div>
          <div class="meta_row"><span class="meta_k">更新时间</span><span>{{ fmtTime(row.utime) }}</span></div>
        </div>
        <div class="card_tags">
          <el-tag v-for="t in row.tools || []" :key="t" size="mini" type="info">{{ t }}</el-tag>
          <span v-if="!(row.tools && row.tools.length)" class="tag_empty">继承主员工全部工具</span>
        </div>
        <div class="card_tags rail_tags">
          <el-tag v-for="r in row.rails || []" :key="r" size="mini" type="warning">{{ r }}</el-tag>
          <span v-if="!(row.rails && row.rails.length)" class="tag_empty">继承父级 Rail</span>
        </div>
        <div v-if="canWrite" class="card_actions">
          <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
        </div>
      </div>
      <el-empty v-if="!loading && !tableData.length"
                :description="agentId ? '暂无子代理数据' : '请先选择所属数字员工'" class="cards_empty" />
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagesize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!-- 子代理编辑抽屉：与技能页一致的右侧抽屉交互 -->
    <el-drawer :visible.sync="editVisible" direction="rtl" size="560px" :with-header="false"
               :modal="true" append-to-body :modal-append-to-body="true"
               class="sa_drawer" :before-close="closeEdit" @open="raiseDrawer">
      <div class="drawer_head">
        <span>{{ isEdit ? '编辑子代理' : '新增子代理' }}</span>
        <i class="el-icon-close drawer_close" @click="closeEdit"></i>
      </div>
      <div class="drawer_body">
        <el-alert type="info" :closable="false" class="drawer_tip"
                  title="子代理由主 Agent 通过 subagent.invoke(name, task) 按调用名唤起，拥有独立上下文、工具白名单与迭代预算。" />
        <el-form ref="form" :model="form" :rules="rules" label-width="96px" size="small">
          <el-form-item label="所属员工">
            <span class="readonly_text">{{ currentAgentLabel }}</span>
          </el-form-item>
          <el-form-item label="调用名" prop="name">
            <el-input v-model="form.name" maxlength="64" placeholder="同主员工下唯一，模型以该名引用" />
          </el-form-item>
          <el-form-item label="展示名">
            <el-input v-model="form.display_name" maxlength="64" placeholder="默认同调用名" />
          </el-form-item>
          <el-form-item label="职责描述">
            <el-input v-model="form.description" type="textarea" :rows="3" maxlength="500"
                      placeholder="将注入主 Agent 能力目录，用于模型判断何时委派" />
          </el-form-item>
          <el-form-item label="角色提示词">
            <el-input v-model="form.system_prompt" type="textarea" :rows="6" maxlength="6000"
                      placeholder="独立系统提示词，定义子代理的身份、目标与输出要求" />
          </el-form-item>
          <el-form-item label="工具白名单">
            <el-select v-model="form.tools" multiple filterable allow-create default-first-option
                       placeholder="留空=继承主员工全部工具" style="width: 100%">
              <el-option v-for="t in toolOptions" :key="t.name" :label="t.name" :value="t.name" />
            </el-select>
            <div class="field_tip">仅可选择/填写完整能力名；留空表示继承主员工能力清单</div>
          </el-form-item>
          <el-form-item label="运行时 Rail">
            <el-select v-model="form.rails" multiple filterable allow-create default-first-option
                       placeholder="留空=继承父级 Rail" style="width: 100%">
              <el-option v-for="r in railOptions" :key="r.name"
                         :label="r.name + '（' + r.description + '）'" :value="r.name" />
            </el-select>
            <div class="field_tip">Rail 在工具调用前后生效（脱敏/裁剪/策略拦截）；子代理只能与父级集合取交集</div>
          </el-form-item>
          <el-form-item label="迭代轮次">
            <el-input-number v-model="form.max_iterations" :min="1" :max="8" :step="1" />
            <span class="field_tip inline">工具循环上限，1-8 轮（默认 6）</span>
          </el-form-item>
          <el-form-item label="模型配置">
            <el-select v-model="form.model_config_id" clearable filterable
                       placeholder="未配置（继承主员工模型）" style="width: 100%">
              <el-option v-for="m in modelOptions" :key="m.config_id"
                         :label="(m.name || m.config_id) + (m.chat_model ? '（' + m.chat_model + '）' : '')"
                         :value="m.config_id" />
            </el-select>
          </el-form-item>
          <el-form-item label="启用">
            <el-switch v-model="form.enabled" />
            <span class="field_tip inline">仅启用项会被注入主员工能力目录并可被调用</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer_footer">
        <el-button @click="closeEdit">取 消</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm">保 存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { agentBody, isAdminAcc, isEnterprise } from '../utils'

// 子代理管理：按主 Agent 维度维护可委派的独立子代理（企业可写，个人只读）
export default {
  name: 'AiAgentSubAgents',
  data() {
    return {
      canWrite: isEnterprise(),
      agentOptions: [],
      agentId: '',
      queryForm: { name: '', enabled: '' },
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      editVisible: false,
      isEdit: false,
      saving: false,
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: '请输入调用名', trigger: 'blur' }]
      },
      toolOptions: [],
      toolOptsLoaded: false,
      modelOptions: [],
      modelOptsLoaded: false,
      railOptions: [],
      railOptsLoaded: false
    }
  },
  computed: {
    currentAgentLabel() {
      const a = this.agentOptions.find(x => x.agent_id === this.agentId)
      return a ? (a.display_name || a.name) : '-'
    }
  },
  mounted() {
    if (isAdminAcc()) return
    this.loadAgents()
  },
  methods: {
    emptyForm() {
      return {
        agent_id: '', name: '', display_name: '', description: '', system_prompt: '',
        tools: [], rails: [], max_iterations: 6, model_config_id: '', enabled: true
      }
    },
    // 供主入口 Tab 激活联动
    onActivate() {
      this.loadAgents()
    },
    loadAgents() {
      return this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsList,
        agentBody({ page: 1, limit: 0, status: 'active' })).then((res) => {
        if (res.data.code === 0 || res.data.code === '0') {
          this.agentOptions = res.data.data.data || []
          if (!this.agentId && this.agentOptions.length) {
            this.agentId = this.agentOptions[0].agent_id
          }
          if (this.agentId) this.loadList()
        }
      }).catch(() => {})
    },
    onAgentChange() {
      this.currentPage = 1
      this.tableData = []
      this.total = 0
      if (this.agentId) this.loadList()
    },
    loadList() {
      if (!this.agentId) { this.tableData = []; this.total = 0; return }
      this.loading = true
      const data = { page: this.currentPage, limit: this.pagesize, agent_id: this.agentId }
      if (this.queryForm.name) data.name = this.queryForm.name
      if (this.queryForm.enabled !== '') data.enabled = this.queryForm.enabled
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSubAgentsList, agentBody(data)).then((res) => {
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    onSearch() {
      this.currentPage = 1
      this.loadList()
    },
    resetQuery() {
      this.queryForm = { name: '', enabled: '' }
      this.onSearch()
    },
    handleSizeChange(val) { this.pagesize = val; this.loadList() },
    handleCurrentChange(val) { this.currentPage = val; this.loadList() },
    openAdd() {
      if (!this.agentId) {
        this.$message({ type: 'warning', message: '请先选择所属数字员工' })
        return
      }
      this.form = this.emptyForm()
      this.form.agent_id = this.agentId
      this.isEdit = false
      this.editVisible = true
      this.loadToolOpts()
      this.loadModelOpts()
      this.loadRailOpts()
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    openEdit(row) {
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSubAgentsGet,
        agentBody({ agent_id: row.agent_id, sub_agent_id: row.sub_agent_id })).then((res) => {
        if (res.data.code != 0) return
        const d = res.data.data || {}
        this.form = {
          agent_id: d.agent_id,
          sub_agent_id: d.sub_agent_id,
          name: d.name || '',
          display_name: d.display_name || '',
          description: d.description || '',
          system_prompt: d.system_prompt || '',
          tools: d.tools || [],
          rails: d.rails || [],
          max_iterations: d.max_iterations || 6,
          model_config_id: d.model_config_id || '',
          enabled: d.enabled !== false
        }
        this.isEdit = true
        this.editVisible = true
        this.loadToolOpts()
        this.loadModelOpts()
        this.loadRailOpts()
        this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      }).catch(() => {})
    },
    closeEdit() {
      this.editVisible = false
    },
    raiseDrawer() {
      this.$nextTick(() => {
        if (this.$el && this.$el.style) this.$el.style.zIndex = 4000
      })
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.saving = true
        const payload = {
          agent_id: this.form.agent_id || this.agentId,
          name: this.form.name,
          display_name: this.form.display_name,
          description: this.form.description,
          system_prompt: this.form.system_prompt,
          tools: this.form.tools || [],
          rails: this.form.rails || [],
          max_iterations: Number(this.form.max_iterations) || 6,
          model_config_id: this.form.model_config_id,
          enabled: !!this.form.enabled
        }
        if (this.isEdit) payload.sub_agent_id = this.form.sub_agent_id
        const url = this.isEdit ? this.$baseUrl.aiAgentSubAgentsEdit : this.$baseUrl.aiAgentSubAgentsAdd
        this.$tools.asyncPost(this, url, agentBody(payload)).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: res.data.msg || '操作成功' })
            this.editVisible = false
            if (!this.isEdit) this.currentPage = 1
            this.loadList()
          }
          this.saving = false
        }).catch((err) => {
          this.saving = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      })
    },
    handleDel(row) {
      this.$MessageBox.confirm('删除后该子代理不可再被主员工调用，确认删除？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSubAgentsDel,
          agentBody({ agent_id: row.agent_id, sub_agent_id: row.sub_agent_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.loadList()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },
    loadToolOpts() {
      if (this.toolOptsLoaded) return
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentToolsList,
        agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) {
          this.toolOptions = res.data.data.data || []
          this.toolOptsLoaded = true
        }
      }).catch(() => {})
    },
    loadModelOpts() {
      if (this.modelOptsLoaded) return
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentModelsConfigList,
        agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) {
          this.modelOptions = res.data.data.data || []
          this.modelOptsLoaded = true
        }
      }).catch(() => {})
    },
    loadRailOpts() {
      if (this.railOptsLoaded) return
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSubAgentsRailsList,
        agentBody({})).then((res) => {
        if (res.data.code == 0) {
          this.railOptions = res.data.data || []
          this.railOptsLoaded = true
        }
      }).catch(() => {})
    },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    }
  }
}
</script>

<style lang="less" scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
  .query_form {
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}
.sa_cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
  padding: 12px;
  min-height: 240px;
  background: #f9fafd;
  border-top: 1px solid #e9eaec;
}
.sa_card {
  display: flex;
  flex-direction: column;
  min-height: 200px;
  padding: 12px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 4px #c0bfbf;
}
.card_head {
  display: flex;
  align-items: center;
  gap: 8px;
  .card_icon { color: #409eff; font-size: 16px; }
  .card_name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .card_del {
    color: #c0c4cc;
    cursor: pointer;
    &:hover { color: #f56c6c; }
  }
}
.card_summary {
  height: 36px;
  margin: 8px 0;
  font-size: 12px;
  line-height: 18px;
  color: #909399;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card_meta {
  font-size: 12px;
  color: #606266;
  .meta_row {
    display: flex;
    justify-content: space-between;
    padding: 2px 0;
  }
  .meta_k { color: #909399; }
}
.card_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-height: 22px;
  margin-top: 8px;
  overflow: hidden;
  .tag_empty { font-size: 12px; color: #c0c4cc; }
}
.rail_tags { max-height: 22px; margin-top: 4px; }
.card_actions {
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid #f2f2f2;
}
.cards_empty { grid-column: 1 / -1; }
.sa_drawer {
  /deep/ .el-drawer__body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
}
.drawer_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 20px;
  border-bottom: 1px solid #ebeef5;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  .drawer_close {
    font-size: 20px;
    color: #909399;
    cursor: pointer;
    &:hover { color: #f56c6c; }
  }
}
.drawer_body {
  flex: 1;
  padding: 16px 20px 8px;
  overflow: auto;
}
.drawer_footer {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}
.drawer_tip { margin-bottom: 14px; }
.readonly_text { color: #606266; }
.field_tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  &.inline { margin-left: 10px; }
}
</style>
